import React from "react";
import ImageCard from "../ImageCard";
import ImageDropper from "../ImageDropper";
import HorizontalDragList from "components/Drag/HorizontalList";
import _ from "lodash";

const MultiImageUploader = ({ files = [], onFileSelected = (files) => { }, onFileChanged = (files) => { } }) => {

    const onOrderChanged = (reorderedItems) => {
        console.log("onOrderChanged", reorderedItems);
        const newFiles = reorderedItems.map((item) => item.content.props.file);
        console.log("newFiles", newFiles);
        onFileChanged(newFiles);
    }

    const onRemoved = (file) => {
        console.log("onRemoved", file, files);
        const filteredFiles = files.filter((f) => f.hash !== file.hash);
        onFileChanged(filteredFiles);
    }

    return (
        <div className="overflow-auto">
            <div className="flex justify-center p-2 min-w-max space-x-2">
                <div hidden={_.isEmpty(files)}>
                    <HorizontalDragList
                        itemsExternal={files?.map((file, index) => ({
                            id: `${index}`,
                            content: (
                                <ImageCard
                                    file={file}
                                    index={index}
                                    onRemove={onRemoved}
                                />
                            )
                        }))}
                        setItemsExternal={onOrderChanged}
                    />
                </div>

                <div className="w-40 h-40">
                    <ImageDropper onFilesSelected={onFileSelected}></ImageDropper>
                </div>
            </div>
        </div>
    )
}

export default MultiImageUploader;
